import { usePostHog } from 'posthog-js/react';
import { MouseEvent, useState } from 'react';
import { trackAndNavigate } from '../../../Config/libs/analytics';
import { PostHogFeatureFlagEnum } from '../../enum/PostHogEvent.enum';
import { OAUTH_TRACKING_KEY } from './useSocialRegister.hook';

export const useSocialLogin = () => {
  const postHog = usePostHog();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleSocialLogin = (
    event: MouseEvent<HTMLButtonElement>,
    provider: string,
    link: string,
  ): void => {
    event.preventDefault();
    if (isNavigating) return;
    setIsNavigating(true);

    // Store variant in localStorage before OAuth redirect for tracking after success
    const backgroundVariant = postHog.getFeatureFlag(PostHogFeatureFlagEnum.SignupBackgroundTest);
    localStorage.setItem(
      OAUTH_TRACKING_KEY,
      JSON.stringify({
        variant: backgroundVariant,
        provider: provider.toLowerCase(),
        timestamp: Date.now(),
      }),
    );

    trackAndNavigate(
      `login_${provider}_click`,
      { event_category: 'User login', event_label: 'login_form' },
      () => {
        window.location.href = link;
      },
    );
  };

  return {
    handleSocialLogin,
    isNavigating,
  };
};
